import React from 'react';

// Permissions
export const PermissionContext = React.createContext(true);
